const resetClosestHeight = (el, selector) => {
	el.closest(selector).css('height', 'auto');
};

export default resetClosestHeight;



/** WEBPACK FOOTER **
 ** ./app/scripts/util/dom/resetClosestHeight.js
 **/